export default "__VITE_ASSET__FMB6Z2sg__"